import React, { useState, useEffect, useRef, useMemo } from "react";
import { Row, Button, Col, Input, Space, Typography, Badge, message } from "antd";
import { CloseSquareFilled, CodeSandboxOutlined } from "@ant-design/icons";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import Back from "../../../assets/images/backIcon.svg";
import FilterIcon from "../../../assets/images/filterNewICon.svg";
import vegIcon from "../../../assets/images/veg.png";
import eggIcon from "../../../assets/images/egg.png";
import removeBg from "../../../assets/images/removebg.png";
import { v4 as uuidv4 } from "uuid";
{
}
import "./restaurantStyle.css";
import db from "../../../database";
import groupBy from "lodash/groupBy";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../../utils/getMultilingualText";
import { useEventBus } from "../../../lib/components/EventBusProvider";
import TableFeatures from "./Tables-Management/TableFeatures";
import ReprintKotDialog from "./ReprintKotDialog";
import { SyncData } from "./Tables-Management/SyncData";
import useRestaurantStore from "../../../stores/useRestaurantStore";
import SplitBillScreen from "./components/SplitBillScreen";
import ProductPanelDrawer from "./components/ProductPanelDrawer";
import ParkedOrdersDrawer from "./components/ParkedOrdersDrawer";
import AddOnSelectionModal from "./components/AddOnSelectionModal";
import CancelOrderItemsModal from "./components/CancelOrderItemsModal";
import CopyKOTModal from "./components/CopyKOTModal";
import SplitBillModal from "./components/SplitBillModal";
import SaleTypeModal from "./components/SaleTypeModal";
import ProductCenterModal from "./components/ProductCenterModal";
import OrderListComponent from "./OrderListComponent";
import CartOrderSidebar from "./components/CartOrderSidebar";
import MenuCategoryPanel from "./components/MenuCategoryPanel";
import MenuProductGrid from "./components/MenuProductGrid";
import AdditionalChargesDrawer from "./components/AdditionalChargesDrawer";
import ItemNotesDrawer from "./components/ItemNotesDrawer";
import useAdditionalCharges from "./hooks/useAdditionalCharges";
import useSplitBill from "./hooks/useSplitBill";
import useCopyKOT from "./hooks/useCopyKOT";
import useAuthStore from "../../../stores/useAuthStore";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useCartStore from "../../../stores/useCartStore";
import useSessionStore from "../../../stores/useSessionStore";
import { productPriceOnScan } from "../../../services/generic";
import useWindowDimensions from "../../../hooks/useWindowDimensions";

const MenuLayout = (props) => {
  const {
    paymentModalInputRef,
    tillAccessData,
    setSelectedProductInCart,
    selectedProductId,
    setSelectedProductId,
    manualDiscountRestaurant,
    selectedSaleType,
    setSelectedSaleType,
    cart,
    restaurantProductCategory,
    productsData,
    pickProduct,
    decreaseProductQty,
    deleteProduct,
    increaseProductQty,
    handleOrder,
    handleVoid,
    addDefinedProductWithAddons,
    addProductWithAddons,
    setKeyValue,
    paymentVisible,
    setPaymentVisible,
    userPreferences,
    setDisplayCustomerSearch,
    setOcupiedTablesData,
    setReservedTablesData,
    categorieFlag,
    setCategorieFlag,
    setCart,
    showProducts,
    setShowProducts,
    setProductsData,
    saleTypeProducts,
    setSaleTypeProducts,
    requestPayment,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    setAmount,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    processOrder,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    handleAmount,
    handleCashPayment,
    showSplitBill,
    setShowSplitBill,
    splitBillScreen,
    setSplitBillScreen,
    numSplits,
    setNumSplits,
    showAllItems,
    setShowAllItems,
    splitCarts,
    setSplitCarts,
    saleType,
    selectedTable,
    isSplitBill,
    setIsSplitBill,
    currentSplitIndex,
    setCurrentSplitIndex,
    recordState,
    setRecardState,
    documentSequence,
    setDocumnetSequence,
    clearCart,
    removeSplit,
    setRemoveSplit,
    mainTableData,
    setMainTableData,
    clearProductSearchResults,
    setOpen,
    setInputName,
    keyboard,
    handleSelectProduct,
    selectedProductInCart,
    selectedProducts,
    setSelectedproducts,
    showSendToKitchen,
    setShowSendToKitchen,
    setSearchhistoryInput,
    searchHistoryInput,
    setFireItems,
    fireItems,
    fireMode,
    setFireMode,
    pendingFireItems,
    setPendingFireItems,
    handleCopyKOT,
    copyKOTVisible,
    setCopyKOTVisible,
    groupedFiredItems,
    setGroupedFiredItems,
    openCopyKOTModal,
    selectedCopyItems,
    setSelectedCopyItems,
    seatGuestDrawerOpen,
    setSeatGuestDrawerOpen,
    transferBill,
    setTransferBill,
    setOederedData,
    handleDisplayOk,
    productsList,
    setTableList,
    setTableCards,
    cancelKotItems,
    setCancelKotItems,
    openDisplayParkedBillModal,
    filterdParkedList,
    setFilterdParkedList,
    retrieveParkedData,
    discardMessage,
    parkedList,
    setParkedList,
    handleBillPrint,
    displayAddOnSelection,
    setDisplayAddOnSelection,
    setSelectedSaleTypeIndex,
    addonSourceItem,
    setAddonSourceItem,
    showAddonsCustomizePopup,
    setShowAddonsCustomizePopUp,
    addonRepeatDisabled,
    setAddonRepeatDisabled,
    selectedProduct,
    setSelectedProduct,
    setAddOnsList,
    addOnsList,
    handleAddOnModal,
    productSearchInput,
    setProductSearchInput,
    loading,
    setLoading,
  } = props;

  const localCart = cart;
  const { t } = useTranslation();
  const { Text } = Typography;
  const { isMobile } = useWindowDimensions();
  const [mobileCartOpen, setMobileCartOpen] = useState(false);
  const [productCategoriesList, setProductCategoriesList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemNotes, setSelectedItemNotes] = useState("");
  const [notesValue, setNotesValue] = useState("");
  const [notesPopup, setNotesPopup] = useState(false);
  const [lineRemarks, setLineRemarks] = useState({});
  const [categorieName, setCategorieName] = useState("");
  const [instructions, setInstructions] = useState(notesValue);
  const tillData = useAuthStore((s) => s.tillData);
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const showImage = posConfig?.showImage === "Y";
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

  // Add-ons modal state
  const [categoryLookup, setCategoryLookup] = useState({});
  const [groupedProducts, setGroupedProducts] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { dispatchEvent } = useEventBus();
  const [isAllParkedState, setIsAllParkedState] = useState(false);
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [selectCategotyList, setSelectCategotyList] = useState([]);
  const productPanelSearchRef = useRef(null);
  const [defaultCategorySet, setDefaultCategorySet] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const allItemsFired = cart?.items?.length > 0 && cart?.items?.every((i) => i.order === "Y");
  const [showReprintKotDialog, setShowReprintKotDialog] = useState(false);
  const [splitOnItem, setSplitOnItem] = useState(false);
  const [parkedDrawerOpen, setParkedDrawerOpen] = useState(false);
  const storedParkedList = useSessionStore.getState().parkedList || [];
  const [showProdCenterModal, setShowProdCenterModal] = useState(false);
  const [prodItem, setProdItem] = useState(null);
  const [saleTypeModalOpen, setSaleTypeModalOpen] = useState(false);
  const [saleTypeModalItem, setSaleTypeModalItem] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  // [TSK-2931] Qty to cancel per selected line, keyed by fbOrderLineId. An id absent from
  // this map (e.g. "Cancel All") means "cancel the full remaining quantity" — today's behavior.
  const [cancelQtyMap, setCancelQtyMap] = useState({});

  const cartObj = cart || {};
  const userAccessController = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const layout = userAccessController.layout;
  const filteredCartObj = {
    ...cartObj,
    // weight is overridden to the chosen cancel qty so the cancel-KOT reprint shows the
    // quantity actually being cancelled, not the item's full ordered quantity.
    items: (cartObj.items || [])
      .filter((item) => selectedItemIds.includes(item.fbOrderLineId))
      .map((item) => ({ ...item, weight: cancelQtyMap[item.fbOrderLineId] ?? item.weight })),
  };
  const usernameData = useAuthStore.getState().username || "";
  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
  const matchedRep = salesReps.find((rep) => rep?.name === usernameData);
  const [salesRepName, setSalesRepName] = useState();

  // ── Custom hooks ───────────────────────────────────────────────
  const additionalChargesHook = useAdditionalCharges({ pricePrecision });
  const {
    additionalCharges,
    setAdditionalCharges,
    serviceChargeEnabled,
    setServiceChargeEnabled,
    serviceChargePercentage,
    setServiceChargePercentage,
    tipMode,
    setTipMode,
    tipPercentage,
    setTipPercentage,
    tipAmount,
    setTipAmount,
    deliveryCharge,
    setDeliveryCharge,
    packingCharge,
    setPackingCharge,
    roundingOption,
    setRoundingOption,
    computeCharges,
    handleAdditionalCharges,
    handleApplyCharges,
    resetToInitialState,
  } = additionalChargesHook;

  const subtotal = cart?.subTotal || 0;
  const { serviceChargeAmount, tipTotal, deliveryChargeAmount, packingChargeAmount } = computeCharges(subtotal);
  const AdditionalChargesTotal = serviceChargeAmount + tipTotal + deliveryChargeAmount + packingChargeAmount;

  const splitBillHook = useSplitBill({ pricePrecision });
  const {
    itemSplitMap,
    setItemSplitMap,
    groupedItems,
    setGroupedItems,
    categorySplitSelection,
    setCategorySplitSelection,
    openCategory,
    setOpenCategory,
    toggleCategory,
    splitWithPrecision,
    buildSplitCarts,
    handleToggleItemSplit: handleToggleItemSplitRaw,
    assignWholeCategory: assignWholeCategoryRaw,
  } = splitBillHook;

  // Wrap to pass cart/numSplits/setSplitCarts
  const handleToggleItemSplit = (item, splitIndex) => handleToggleItemSplitRaw(item, splitIndex, cart, numSplits, setSplitCarts);

  const assignWholeCategory = (group, splitIndexToRemove, undo = false) => assignWholeCategoryRaw(group, splitIndexToRemove, cart, numSplits, setSplitCarts, undo);

  const totalSplits = splitWithPrecision(cart.total, numSplits, pricePrecision);
  const taxSplits = splitWithPrecision(cart.tax, numSplits, pricePrecision);

  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y";

  const copyKOTHook = useCopyKOT({
    cart,
    setCart,
    recordState,
    posConfig,
    CWHardwareController,
    userPreferences,
    setOcupiedTablesData,
    setReservedTablesData,
    setTableCards,
    setTableList,
    setCopyKOTVisible,
    setSelectedCopyItems,
    setShowProducts,
    setKeyValue,
  });
  const { handleCopyKOTConfirm } = copyKOTHook;

  // ── Helpers ────────────────────────────────────────────────────
  const toFixedTruncate = (num, decimalPlaces = 3) => {
    if (isNaN(num) || num === null) num = 0;
    const factor = Math.pow(10, decimalPlaces);
    const truncatedNum = Math.trunc(num * factor) / factor;
    return truncatedNum.toFixed(decimalPlaces);
  };

  const isReturnOrder = localCart?.isReturn === true || localCart?.isReturn === "true" || localCart?.isReturn === "Y";

  const handleAdvanceToggle = (checked) => {
    const updatedCart = { ...cart };
    if (!cart.wasLayaway) {
      if (checked) {
        updatedCart.layAway = "Y";
        updatedCart.preOrder = "Y";
        updatedCart.statusType = "layAway";
        updatedCart.isAdvance = "Y";
      } else {
        updatedCart.layAway = "N";
        updatedCart.preOrder = "N";
        updatedCart.statusType = "";
        updatedCart.isAdvance = "N";
      }
    }
    if (cart.wasLayaway) {
      updatedCart.isAdvance = checked ? "Y" : "N";
      updatedCart.finishLayaway = !checked;
      updatedCart.layAway = "Y";
      updatedCart.statusType = checked ? "layAway" : "";
    }
    setCart(updatedCart);
  };

  const guestName = useRestaurantStore.getState().tableName?.guestName;

  const groupedKotItems = useMemo(() => {
    const result = {};
    (cart?.items || []).forEach((item) => {
      const key = item.kotTokenId || "NO_KOT";
      if (!result[key]) result[key] = [];
      result[key].push(item);
    });
    return result;
  }, [cart?.items]);

  // Default a newly-selected line's cancel qty to its full remaining weight (today's
  // whole-line-cancel behavior); drop the entry once deselected.
  const clearCancelQty = (ids) => {
    setCancelQtyMap((prev) => {
      const next = { ...prev };
      ids.forEach((id) => delete next[id]);
      return next;
    });
  };
  const defaultCancelQty = (items) => {
    setCancelQtyMap((prev) => {
      const next = { ...prev };
      items.forEach((item) => {
        if (!(item.fbOrderLineId in next)) next[item.fbOrderLineId] = item.weight;
      });
      return next;
    });
  };

  const toggleItem = (fbOrderLineId, item) => {
    setSelectedItemIds((prev) => (prev.includes(fbOrderLineId) ? prev.filter((id) => id !== fbOrderLineId) : [...prev, fbOrderLineId]));
    if (selectedItemIds.includes(fbOrderLineId)) {
      clearCancelQty([fbOrderLineId]);
    } else if (item) {
      defaultCancelQty([item]);
    }
  };

  const toggleKot = (items, checked) => {
    const ids = items.map((i) => i.fbOrderLineId);
    setSelectedItemIds((prev) => (checked ? Array.from(new Set([...prev, ...ids])) : prev.filter((id) => !ids.includes(id))));
    if (checked) {
      defaultCancelQty(items);
    } else {
      clearCancelQty(ids);
    }
  };

  const toggleAll = (checked) => {
    if (!checked) {
      setSelectedItemIds([]);
      setCancelQtyMap({});
      return;
    }
    const cancellableItems = Object.values(groupedKotItems)
      .flat()
      .filter((item) => item.isCanceled !== "Y" && (item.orderStatus === "OR" || item.orderStatus === "IP"));
    setSelectedItemIds(cancellableItems.map((item) => item.fbOrderLineId));
    defaultCancelQty(cancellableItems);
  };

  useEffect(() => {
    const getSalesRepName = async () => {
      const tableData = useRestaurantStore.getState().tableName;
      if (tableData) {
        const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableData?.cwrFbTableId).first();
        if (tableRecord?.waiter) {
          tillData.tillAccess.csBunit.salesRep?.find((rep) => {
            if (rep?.salesRepresentId === tableRecord?.waiter) setSalesRepName(rep?.name);
          });
        }
      }
    };
    getSalesRepName();
  }, []);

  const categoryCounts = useMemo(() => {
    return saleTypeProducts.reduce((acc, product) => {
      const categoryId = product.mProductCategoryId || "uncategorized";
      acc[categoryId] = (acc[categoryId] || 0) + 1;
      return acc;
    }, {});
  }, [saleTypeProducts]);

  const handleCategoryClick = async (categoryId, categoryName) => {
    setLoading(true);
    setSelectedCategory(categoryId);
    setCategorieName(categoryName);
    try {
      await restaurantProductCategory(categoryId);
      setProductSearchInput("");
      let filteredProducts = [];
      if (productSearchInput.trim().length > 0) {
        const searchInput = productSearchInput.toLowerCase();
        filteredProducts = saleTypeProducts.filter(
          (product) =>
            product.mProductCategoryId === categoryId &&
            (product.name?.toLowerCase().includes(searchInput) || product.value?.toLowerCase().includes(searchInput) || product.upc?.toLowerCase().includes(searchInput)) &&
            product.isBestSeller
        );
      } else {
        filteredProducts = saleTypeProducts.filter((product) => product.mProductCategoryId === categoryId && product.isBestSeller);
      }
      setProductsData(filteredProducts);
    } catch (error) {
      console.error("Error in restaurantProductCategory:", error);
    }
    setCategorieFlag(true);
    setLoading(false);
  };

  const getFoodTypeIcon = (foodType) => {
    if (!foodType) return null;
    if (foodType === "VEG") return vegIcon;
    if (foodType === "NVG") return removeBg;
    if (foodType === "EGG") return eggIcon;
    return null;
  };

  const bestsellerCategories = useMemo(
    () => productCategoriesList.filter((category) => saleTypeProducts.some((product) => product.mProductCategoryId === category.mProductCategoryId && product.isBestSeller)),
    [productCategoriesList, saleTypeProducts]
  );

  const productionCentersOptions = useMemo(() => {
    if (!productsList || productsList.length === 0) return [];
    const centersMap = new Map();
    productsList.forEach((item) => {
      const id = item.productionCenterId?.trim();
      if (id && !centersMap.has(id)) {
        centersMap.set(id, { label: item.productionCenter?.trim() || id, value: id });
      }
    });
    return Array.from(centersMap.values());
  }, [productsList]);

  const pastelColors = ["#F8C8DC", "#FFD1D1", "#FFE5B4", "#FFF4C1", "#D4F4DD", "#C8E6F5", "#D1E8FF", "#E6E6FA", "#F0D4F0", "#FFE4E1", "#E0F7FA", "#F5F5DC"];
  const getColorFromId = (id) => {
    const hash = id.split("").reduce((a, b) => a + b.charCodeAt(0), 0);
    return pastelColors[hash % pastelColors.length];
  };

  useEffect(() => {
    if (filterDrawer && productCategoriesList.length > 0) {
      const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));
      const firstCategory = sortedCategories[0];
      if (firstCategory) {
        setSelectCategotyList([firstCategory.mProductCategoryId]);
        setCategorieName(firstCategory.name);
        setSelectedCategory(firstCategory.mProductCategoryId);
        restaurantProductCategory(firstCategory.mProductCategoryId);
        setCategorieFlag(true);
      }
    }
  }, [filterDrawer, productCategoriesList]);

  useEffect(() => {
    if (productSearchInput.length > 0) {
      const searchedProducts = saleTypeProducts.filter((product) => {
        const searchInput = productSearchInput.toLowerCase();
        return product.name?.toLowerCase().includes(searchInput) || product.value?.toLowerCase().includes(searchInput) || product.upc?.toLowerCase().includes(searchInput);
      });
      if (searchedProducts.length > 0) setSelectedCategory(searchedProducts[0].mProductCategoryId);
    }
  }, [productSearchInput, saleTypeProducts]);

  useEffect(() => {
    if (!defaultCategorySet && productCategoriesList.length > 0 && saleTypeProducts.length > 0 && bestsellerCategories.length > 0) {
      const sortedCategories = [...bestsellerCategories].sort((a, b) => a.name.localeCompare(b.name));
      if (sortedCategories[0]) {
        setSelectedCategory(sortedCategories[0].mProductCategoryId);
        setDefaultCategorySet(true);
      }
      if (bestsellerCategories.length > 0 && !selectedCategory) {
        setSelectedCategory(bestsellerCategories[0].mProductCategoryId);
      }
    }
  }, [bestsellerCategories, productCategoriesList, saleTypeProducts, defaultCategorySet]);

  const frequentProducts = productsData.filter((item) => item.isBestSeller);
  const nonfrequentProducts = productsData.filter((item) => !item.isBestSeller);

  const applySearchFilter = (searchValue, categoryIds) => {
    const value = searchValue.toLowerCase().trim();
    if (!value) {
      if (categoryIds.length === 0) return saleTypeProducts;
      return saleTypeProducts.filter((product) => categoryIds.includes(product.mProductCategoryId));
    }
    return saleTypeProducts.filter((product) => {
      const matchesText = product.name.toLowerCase().includes(value) || product.value?.toLowerCase().includes(value) || product.code?.toLowerCase().includes(value);
      const matchesCategory = categoryIds.length === 0 || categoryIds.includes(product.mProductCategoryId);
      return matchesText && matchesCategory;
    });
  };

  useEffect(() => {}, [selectedProduct]);

  // ── Add-on handlers ────────────────────────────────────────────
  const handleAddOnValue = (e, fieldName) => {
    const value = e.target.value;
    const groupId = value.mAddonGroup.mAddonGroupId;
    const max = value.mAddonGroup.maxqty;
    let newSelectedAddons = [...selectedAddons];

    if (fieldName === "addOnRadio") {
      newSelectedAddons = newSelectedAddons.filter((item) => item.mAddonGroup.mAddonGroupId !== groupId);
      newSelectedAddons.push(value);
      setSelectedAddons(newSelectedAddons);
      return;
    }

    const groupItems = newSelectedAddons.filter((item) => item.mAddonGroup.mAddonGroupId === groupId);
    const existsIndex = newSelectedAddons.findIndex((item) => item.mProductAddOnId === value.mProductAddOnId);

    if (existsIndex !== -1 && !e.target.checked) {
      newSelectedAddons.splice(existsIndex, 1);
      setSelectedAddons(newSelectedAddons);
      return;
    }

    if (groupItems.length >= max) {
      message.warning(`Max ${max} allowed in ${value.mAddonGroup.name}`);
      return;
    }

    newSelectedAddons.push(value);
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = { ...selectedProduct, weight: selectedProduct?.weight || 1 };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Math.max(1, Number(newSelectedProduct.weight) - 1);
    }
    setSelectedProduct({ ...newSelectedProduct });
  };

  const handleAdd = async () => {
    const selectedGroupMap = groupBy(selectedAddons, (a) => a.mAddonGroup.mAddonGroupId);
    const allGroups = groupBy(selectedProduct.productAddons, (a) => a.mAddonGroup.mAddonGroupId);

    for (const groupId in allGroups) {
      const groupInfo = allGroups[groupId][0].mAddonGroup;
      const min = groupInfo.minqty ?? 0;
      const max = groupInfo.maxqty ?? Infinity;
      const selectedCount = selectedGroupMap[groupId]?.reduce((s, a) => s + (a.qty || 1), 0) || 0;
      if (selectedCount < min) {
        message.error(`Please select minimum ${min} from ${groupInfo.name}`);
        return;
      }
      if (selectedCount > max) {
        message.error(`You can select maximum ${max} from ${groupInfo.name}`);
        return;
      }
    }

    const addonsWithWeight = selectedAddons.map((addon) => ({
      ...addon,
      weight: selectedProduct.weight,
      addonQty: addon.qty,
    }));

    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        selectedAddons: addonsWithWeight,
        weight: selectedProduct?.weight || 1,
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice,
      true
    );

    handleAddOnModalClose();
  };

  const updateAddonQty = (addon, change) => {
    const groupId = addon.mAddonGroup.mAddonGroupId;
    const groupName = addon.mAddonGroup.name;
    const max = addon.mAddonGroup.maxqty ?? Infinity;
    const allowQty = addon.mAddonGroup.allowQtySelection === "Y";
    let newAddons = [...selectedAddons];
    const groupItems = newAddons.filter((a) => a.mAddonGroup.mAddonGroupId === groupId);
    const totalQtyInGroup = groupItems.reduce((sum, a) => sum + (a.qty || 0), 0);
    const index = newAddons.findIndex((a) => a.mProductAddOnId === addon.mProductAddOnId);

    if (change === -999 && index !== -1) {
      newAddons.splice(index, 1);
      setSelectedAddons(newAddons);
      return;
    }

    if (change === 1) {
      if (allowQty) {
        if (totalQtyInGroup + 1 > max) {
          message.warning(`Max ${max} allowed in ${groupName}`);
          return;
        }
        if (index !== -1) {
          newAddons[index].qty += 1;
        } else {
          newAddons.push({ ...addon, qty: 1 });
        }
      } else {
        if (groupItems.length >= max) {
          message.warning(`Only ${max} options allowed in ${groupName}`);
          return;
        }
        if (index === -1) newAddons.push({ ...addon, qty: 1 });
      }
    }

    if (change === -1 && index !== -1) {
      if (allowQty) {
        newAddons[index].qty -= 1;
        if (newAddons[index].qty <= 0) newAddons.splice(index, 1);
      } else {
        newAddons.splice(index, 1);
      }
    }

    setSelectedAddons(newAddons);
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };

  const getAddonPreview = (addons = []) => {
    if (!addons.length) return "";
    const names = addons.map((a) => a.name);
    if (names.length <= 2) return names.join(", ");
    return names.slice(0, 2).join(", ") + "…";
  };

  const getAddonSignature = (selectedAddons = []) =>
    selectedAddons
      .map((a) => a.mProductAddOnId)
      .sort()
      .join("|");

  useEffect(() => {
    db.productCategories
      .toArray()
      .then((response) => {
        const result = response.filter((item) => saleTypeProducts?.some((product) => product?.mProductCategoryId === item?.mProductCategoryId));
        setProductCategoriesList(result);
      })
      .catch(console.error);
  }, [saleTypeProducts]);

  const filteredProducts = productsData.filter((product) => product.isBestSeller && product.mProductCategoryId === selectedCategory);

  useEffect(() => {
    if (productCategoriesList?.length > 0 && !filterDrawer) {
      const filtered = productCategoriesList
        .filter((category) => saleTypeProducts.some((product) => product.mProductCategoryId === category.mProductCategoryId && product.isBestSeller))
        .sort((a, b) => a.name.localeCompare(b.name));

      if (filtered.length > 0) {
        const firstCategory = filtered[0];
        setSelectedCategory(firstCategory.mProductCategoryId);
        setCategorieName(firstCategory.name);
        restaurantProductCategory(firstCategory.mProductCategoryId);
        setSaleTypeProducts((prev) => {
          const fp = prev.filter((product) => product.mProductCategoryId === firstCategory.mProductCategoryId && product.isBestSeller);
          setProductsData(fp);
          return prev;
        });
      } else {
        const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));
        if (sortedCategories.length > 0) {
          const firstCategory = sortedCategories[0];
          setSelectedCategory(firstCategory.mProductCategoryId);
          setCategorieName(firstCategory.name);
          restaurantProductCategory(firstCategory.mProductCategoryId);
          setSaleTypeProducts((prev) => {
            const fp = prev.filter((product) => product.mProductCategoryId === firstCategory.mProductCategoryId);
            setProductsData(fp);
            return prev;
          });
        } else {
          setSelectedCategory(null);
          setCategorieName("");
          setProductsData([]);
        }
      }
    }
  }, [productCategoriesList, saleTypeProducts, filterDrawer]);

  useEffect(() => {
    if (productCategoriesList?.length > 0) {
      const defaultCategory = productCategoriesList[0];
      setProductsData(saleTypeProducts.filter((product) => product.mProductCategoryId === defaultCategory.mProductCategoryId));
    } else {
      setProductsData([]);
    }
  }, [saleTypeProducts, productCategoriesList]);

  const cartItems = cart.items;

  useEffect(() => {
    db.productCategories
      .toArray()
      .then((response) => {
        const lookup = response.reduce((acc, category) => {
          acc[category.mProductCategoryId.trim()] = category.name.trim();
          return acc;
        }, {});
        setCategoryLookup(lookup);
      })
      .catch(console.error);

    const grouped = cartItems?.reduce((acc, item) => {
      const categoryName = categoryLookup[item.mProductCategoryId?.trim()] || "";
      if (!acc[categoryName]) acc[categoryName] = [];
      acc[categoryName].push(item);
      return acc;
    }, {});

    setGroupedProducts(grouped);
  }, [cartItems]);

  const hasFiredItems = Object.values(groupedProducts)
    .flat()
    .some((item) => item.order === "Y");

  useEffect(() => {
    if (!cart?.items) return;
    if (splitOnItem) {
      const initMap = {};
      cart.items.forEach((item) => {
        initMap[item.lineId] = Array(numSplits).fill(true);
      });
      setItemSplitMap(initMap);
      const newSplitCarts = buildSplitCarts(cart, numSplits, initMap);
      setSplitCarts(newSplitCarts);
    }
  }, [splitOnItem]);

  useEffect(() => {
    let cartObjState = useCartStore.getState().cart;
    const allParked = cart?.items?.length > 0 && cart?.items?.every((item) => item.parkedItem === true);
    const hasUnparkedItems = cart.items.some((item) => item.parkedItem === false);
    const hasPendingToSend = cartObjState?.items?.some((item) => item.sendQty > 0);
    if (hasUnparkedItems || hasPendingToSend) {
      setShowSendToKitchen(true);
      setIsAllParkedState(false);
    } else {
      setShowSendToKitchen(false);
      setIsAllParkedState(allParked);
    }
  }, [cart?.items]);

  useEffect(() => {
    const matchedProduct = cart.items.find((item) => item.productId === selectedProductInCart?.productId);
    setSelectedproducts((prev) => [...prev, matchedProduct]);
  }, [selectedProductInCart]);

  useEffect(() => {
    setProductSearchInput("");
    setCategorieFlag(false);
  }, []);

  // ── Bill / table status helpers ────────────────────────────────
  const updateTableStatusToBRQ = async () => {
    if (useRestaurantStore.getState().dineIn !== "Y") {
      return;
    }
    const tableInfo = useRestaurantStore.getState().tableName;
    if (!tableInfo?.cwrFbTableId) {
      return;
    }
    const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableInfo.cwrFbTableId).first();
    if (!tableRecord) {
      return;
    }
    if (tableRecord.statusType !== "BRQ") {
      tableRecord.statusType = "BRQ";
      tableRecord.tableSync = "N";
      await db.tableData.put(tableRecord, tableRecord.cwrFbTableId);
      await SyncData(tableRecord, "upsertTableStatus");
      setTableCards?.((prev) => prev.map((t) => (t.cwrFbTableId === tableRecord.cwrFbTableId ? { ...t, ...tableRecord } : t)));
      setTableList?.((prev) => prev.map((t) => (t.cwrFbTableId === tableRecord.cwrFbTableId ? { ...t, ...tableRecord } : t)));
    }
    // Per-table marker — a single global key suppressed the settlement receipt
    // of WHATEVER table settled next, not just the one whose bill was prepared.
    localStorage.setItem(`isPreparedBill_${tableInfo.cwrFbTableId}`, "true");
  };

  const handlePayBillClick = async () => {
    await updateTableStatusToBRQ();
  };

  const renderWaiterName = () => {
    if (salesRepName && useRestaurantStore.getState().dineIn === "Y") {
      return <span style={{ marginLeft: "auto", fontSize: "0.85em", fontWeight: 500, color: "#0F0718", whiteSpace: "nowrap" }}>{salesRepName}</span>;
    }
  };

  const isProductInCart = (product, cart) => cart?.items?.some((item) => item.productId === product.productId);

  // Shared with both the desktop inline sidebar and the mobile bottom-sheet
  // render of CartOrderSidebar below — same component, same props, so
  // behavior stays identical between the two presentations.
  const cartOrderSidebarProps = {
    cart,
    setCart,
    localCart,
    isAllParkedState,
    allItemsFired,
    isReturnOrder,
    saleType,
    groupedProducts,
    hasFiredItems,
    currenciesList,
    pricePrecision,
    toFixedTruncate,
    userPreferences,
    tillData,
    posConfig,
    matchedRep,
    tillaccess,
    salesRepName,
    showDetails,
    setShowDetails,
    serviceChargeAmount,
    tipTotal,
    deliveryChargeAmount,
    packingChargeAmount,
    AdditionalChargesTotal,
    selectedProductId,
    setSelectedProductId,
    setSelectedProductInCart,
    setDisplayCustomerSearch,
    handleAdvanceToggle,
    handleAdditionalCharges,
    handleOrder,
    handlePayBillClick,
    processOrder,
    openDisplayParkedBillModal,
    manualDiscountRestaurant,
    setShowSplitBill,
    setCancelKotItems,
    setFireMode,
    setFireItems,
    setSeatGuestDrawerOpen,
    setTransferBill,
    setProdItem,
    setShowProdCenterModal,
    setShowReprintKotDialog,
    openCopyKOTModal,
    setSaleTypeModalItem,
    setSaleTypeModalOpen,
    setSelectedItem,
    setSelectedItemNotes,
    setNotesValue,
    setNotesPopup,
    paymentModalInputRef,
    setPaymentVisible,
    getAddonPreview,
    renderWaiterName,
    decreaseProductQty,
    increaseProductQty,
    loading,
    setLoading,
  };

  // ── Render ─────────────────────────────────────────────────────
  return (
    <>
      {paymentVisible ? (
        <OrderListComponent
          {...props}
          requestPayment={requestPayment}
          recordState={recordState}
          setRecardState={setRecardState}
          setSearchhistoryInput={setSearchhistoryInput}
          searchHistoryInput={searchHistoryInput}
          setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
          productCategoriesList={productCategoriesList}
          setProductCategoriesList={setProductCategoriesList}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          bestsellerCategories={bestsellerCategories}
          handleCategoryClick={handleCategoryClick}
          saleTypeProducts={saleTypeProducts}
          setSaleTypeProducts={setSaleTypeProducts}
        />
      ) : splitBillScreen ? (
        <SplitBillScreen
          splitCarts={splitCarts}
          setSplitCarts={setSplitCarts}
          splitBillScreen={splitBillScreen}
          setSplitBillScreen={setSplitBillScreen}
          numSplits={numSplits}
          setNumSplits={setNumSplits}
          showAllItems={showAllItems}
          setShowAllItems={setShowAllItems}
          setIsSplitBill={setIsSplitBill}
          setCurrentSplitIndex={setCurrentSplitIndex}
          groupedItems={groupedItems}
          openCategory={openCategory}
          toggleCategory={toggleCategory}
          categorySplitSelection={categorySplitSelection}
          setCategorySplitSelection={setCategorySplitSelection}
          itemSplitMap={itemSplitMap}
          setItemSplitMap={setItemSplitMap}
          assignWholeCategory={assignWholeCategory}
          handleToggleItemSplit={handleToggleItemSplit}
          currenciesList={currenciesList}
          pricePrecision={pricePrecision}
          toFixedTruncate={toFixedTruncate}
          selectedProductId={selectedProductId}
          userPreferences={userPreferences}
          serviceChargeAmount={serviceChargeAmount}
          tipTotal={tipTotal}
          deliveryCharge={deliveryCharge}
          packingCharge={packingCharge}
          setPaymentVisible={setPaymentVisible}
          setRemoveSplit={setRemoveSplit}
          setAmount={setAmount}
          setCart={setCart}
          recordState={recordState}
        />
      ) : (
        <div className="menu-layout-root" style={{ display: "flex", overflow: "hidden" }}>
          {/* ── LEFT: Menu panel ── */}
          <div
            className={`menu-panel-left${cart.items.length > 0 || localCart?.items?.length > 0 ? " menu-panel-left--cart-bar" : ""}`}
            style={{ width: cart.items.length > 0 ? "69%" : "100%", height: "100vh" }}
          >
            {/* Top search row */}
            <Row className="menu-top-search-row" style={{ padding: "0vh 2.5vw 0 1.5vw", fontSize: "1vw", alignItems: "center" }}>
              <Col span={24}>
                <p style={{ fontWeight: 500, paddingLeft: "3px", fontSize: "1.25em", color: "#0F0718", paddingTop: "0.5em", margin: 0 }}>
                  {posConfig?.disableOfflineBilling !== "Y" && (
                    <>
                      {getMultilingualText("Order")}: {cart?.documentno}
                    </>
                  )}
                </p>
              </Col>
              <Col span={24}>
                <div className="menu-top-actions-row" style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "nowrap" }}>
                  {showProducts && (
                    <img
                      src={Back}
                      style={{ height: "4.5vh", cursor: "pointer", flexShrink: 0 }}
                      onClick={async () => {
                        setShowProducts(false);
                        setShowSendToKitchen(false);
                        const updatedTableData = await db.tableData.toArray();
                        setTableCards(updatedTableData);
                        setMainTableData(updatedTableData);
                        setTableList(updatedTableData);
                        setOcupiedTablesData(updatedTableData.filter((t) => t.statusType === "OCU" || t.statusType === "ONG"));
                        setReservedTablesData(updatedTableData.filter((t) => t.statusType === "RES"));
                      }}
                      alt="back"
                    />
                  )}
                  <div className="menu-top-search-wrap" style={{ flex: 1, display: "flex", alignItems: "center", minWidth: 0 }}>
                    <Input
                      placeholder={getMultilingualText("Search for products by code/name")}
                      id="sm-product-search"
                      onChange={(e) => setProductSearchInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "+" || e.key === "=") {
                          e.preventDefault();
                          e.stopPropagation();
                        }
                        if (e.key === "-" && e.target.selectionStart === 0) e.preventDefault();
                      }}
                      className="productSearch-sm"
                      style={{ borderRadius: "20px", padding: "0.8vh 0.8vw", borderColor: "#fff", flex: 1 }}
                      value={productSearchInput}
                      suffix={
                        productSearchInput.length > 0 ? (
                          <CloseSquareFilled style={{ fontSize: "20px", color: "#2F3856", cursor: "pointer" }} onClick={() => setProductSearchInput("")} />
                        ) : null
                      }
                      prefix={<img src={SearchIcon} alt="search" />}
                    />
                    <Button
                      className="menu-search-scan-btn"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "4.5%",
                        margin: "0 1vw 0 0.5vw",
                        borderRadius: "7px",
                        borderColor: "#fff",
                        flexShrink: 0,
                      }}
                      id="sm-product-drawer"
                      onClick={() => {
                        setFilterDrawer(true);
                        setTimeout(() => {
                          if (productPanelSearchRef.current) productPanelSearchRef.current.focus();
                        }, 100);
                      }}
                    >
                      <img src={FilterIcon} style={{ height: "2.7vh" }} alt="filter" />
                    </Button>
                  </div>

                  {/* Parked orders button */}
                  {useRestaurantStore.getState().dineIn
                    ? useRestaurantStore.getState().dineIn !== "Y" && (
                        <Badge
                          className="menu-parked-orders-badge"
                          count={(useSessionStore.getState().parkedList || []).length}
                          overflowCount={99}
                          style={{
                            backgroundColor: "#FF8A00",
                            color: "#fff",
                            fontSize: "11px",
                            fontWeight: 600,
                            minWidth: "18px",
                            height: "18px",
                            lineHeight: "18px",
                            borderRadius: "7px",
                            boxShadow: "0 0 0 2px #fff",
                          }}
                          size="small"
                          offset={[-5, 5]}
                        >
                          <Button
                            onClick={() => {
                              const parkedList = useSessionStore.getState().parkedList || [];
                              const mappedList = parkedList.map((record) => ({
                                ...record,
                                status: "Parked",
                                key: uuidv4().replace(/-/g, "").toUpperCase(),
                                customer: record?.parkedCart?.customer?.name || "",
                                qty: record?.parkedCart?.totalQty || 0,
                              }));
                              useSessionStore.getState().setParkedList(mappedList);
                              setFilterdParkedList(mappedList);
                              setParkedDrawerOpen(true);
                            }}
                            className="menu-parked-orders-btn"
                            style={{ display: "flex", alignItems: "center", gap: "4px", borderRadius: "7px", borderColor: "#fff", padding: "6px 14px", background: "#FFFFFF" }}
                          >
                            <CodeSandboxOutlined style={{ fontSize: "18px", color: "#0F0718" }} />
                            <span className="menu-parked-orders-label" style={{ fontSize: "0.8rem", color: "#0F0718", fontWeight: 500 }}>Parked Orders</span>
                          </Button>
                        </Badge>
                      )
                    : null}
                </div>
              </Col>
            </Row>

            {/* Category + Product grid */}
            <div className="tables-container-category" style={{ display: "flex" }}>
              <MenuCategoryPanel
                bestsellerCategories={bestsellerCategories}
                productCategoriesList={productCategoriesList}
                selectedCategory={selectedCategory}
                loading={loading}
                handleCategoryClick={handleCategoryClick}
              />
              <MenuProductGrid
                loading={loading}
                productSearchInput={productSearchInput}
                bestsellerCategories={bestsellerCategories}
                filteredProducts={filteredProducts}
                saleTypeProducts={saleTypeProducts}
                selectedCategory={selectedCategory}
                cart={cart}
                showImage={showImage}
                currenciesList={currenciesList}
                pricePrecision={pricePrecision}
                getFoodTypeIcon={getFoodTypeIcon}
                getColorFromId={getColorFromId}
                handleAddOnModal={handleAddOnModal}
                pickProduct={pickProduct}
                setSelectedProduct={setSelectedProduct}
                getAddonSignature={getAddonSignature}
                setAddonSourceItem={setAddonSourceItem}
                setAddonRepeatDisabled={setAddonRepeatDisabled}
                setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
                setAddOnsList={setAddOnsList}
              />
            </div>
          </div>

          {/* ── RIGHT: Cart sidebar ── */}
          {(cart.items.length > 0 || localCart?.items?.length > 0) && (
            <>
              {/* Desktop/tablet: unchanged inline sidebar */}
              {!isMobile && <CartOrderSidebar {...cartOrderSidebarProps} />}

              {/* Mobile: sticky summary bar + full-screen bottom sheet, same CartOrderSidebar inside */}
              {isMobile && (
                <>
                  <div className="mobile-cart-summary-bar" onClick={() => setMobileCartOpen(true)}>
                    <span>
                      {cart.items.length} {cart.items.length === 1 ? "item" : "items"}
                    </span>
                    <span className="mobile-cart-summary-total">
                      {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                      {toFixedTruncate(parseFloat(cart.total) + AdditionalChargesTotal, pricePrecision)}
                      {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                    </span>
                    <span>{getMultilingualText("View Cart")} ▲</span>
                  </div>

                  {mobileCartOpen && (
                    <div className="mobile-cart-sheet-overlay" onClick={() => setMobileCartOpen(false)}>
                      <div className="mobile-cart-sheet" onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="mobile-cart-sheet-close" onClick={() => setMobileCartOpen(false)}>
                          ✕
                        </button>
                        <CartOrderSidebar {...cartOrderSidebarProps} />
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      )}

      {/* ── Modals / Drawers ── */}
      <AddOnSelectionModal
        layout={layout}
        displayAddOnSelection={displayAddOnSelection}
        handleAddOnModalClose={handleAddOnModalClose}
        selectedProduct={selectedProduct}
        currenciesList={currenciesList}
        pricePrecision={pricePrecision}
        handleQty={handleQty}
        addOnsList={addOnsList}
        selectedAddons={selectedAddons}
        handleAddOnValue={handleAddOnValue}
        updateAddonQty={updateAddonQty}
        handleAdd={handleAdd}
      />

      <ItemNotesDrawer
        notesPopup={notesPopup}
        setNotesPopup={setNotesPopup}
        notesValue={notesValue}
        setNotesValue={setNotesValue}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        setInstructions={setInstructions}
        cart={cart}
        setCart={setCart}
      />

      <AdditionalChargesDrawer
        additionalCharges={additionalCharges}
        setAdditionalCharges={setAdditionalCharges}
        serviceChargeEnabled={serviceChargeEnabled}
        setServiceChargeEnabled={setServiceChargeEnabled}
        serviceChargePercentage={serviceChargePercentage}
        setServiceChargePercentage={setServiceChargePercentage}
        serviceChargeAmount={serviceChargeAmount}
        tipMode={tipMode}
        setTipMode={setTipMode}
        tipPercentage={tipPercentage}
        setTipPercentage={setTipPercentage}
        tipAmount={tipAmount}
        setTipAmount={setTipAmount}
        deliveryCharge={deliveryCharge}
        setDeliveryCharge={setDeliveryCharge}
        packingCharge={packingCharge}
        setPackingCharge={setPackingCharge}
        roundingOption={roundingOption}
        setRoundingOption={setRoundingOption}
        currenciesList={currenciesList}
        pricePrecision={pricePrecision}
        toFixedTruncate={toFixedTruncate}
        resetToInitialState={resetToInitialState}
        handleApplyCharges={handleApplyCharges}
        setCart={setCart}
      />

      <ProductPanelDrawer
        filterDrawer={filterDrawer}
        setFilterDrawer={setFilterDrawer}
        productSearchInput={productSearchInput}
        setProductSearchInput={setProductSearchInput}
        selectCategotyList={selectCategotyList}
        setSelectCategotyList={setSelectCategotyList}
        setProductsData={setProductsData}
        saleTypeProducts={saleTypeProducts}
        loading={loading}
        productPanelSearchRef={productPanelSearchRef}
        setOpen={setOpen}
        setInputName={setInputName}
        keyboard={keyboard}
        applySearchFilter={applySearchFilter}
        productCategoriesList={productCategoriesList}
        setCategorieName={setCategorieName}
        restaurantProductCategory={restaurantProductCategory}
        setCategorieFlag={setCategorieFlag}
        frequentProducts={frequentProducts}
        nonfrequentProducts={nonfrequentProducts}
        showImage={showImage}
        currenciesList={currenciesList}
        pricePrecision={pricePrecision}
        getColorFromId={getColorFromId}
        handleAddOnModal={handleAddOnModal}
        pickProduct={pickProduct}
      />

      <SplitBillModal
        showSplitBill={showSplitBill}
        setShowSplitBill={setShowSplitBill}
        cart={cart}
        setCart={setCart}
        numSplits={numSplits}
        setNumSplits={setNumSplits}
        currenciesList={currenciesList}
        pricePrecision={pricePrecision}
        toFixedTruncate={toFixedTruncate}
        serviceChargeAmount={serviceChargeAmount}
        tipTotal={tipTotal}
        deliveryChargeAmount={deliveryChargeAmount}
        packingChargeAmount={packingChargeAmount}
        totalSplits={totalSplits}
        taxSplits={taxSplits}
        setIsSplitBill={setIsSplitBill}
        setSplitCarts={setSplitCarts}
        setCurrentSplitIndex={setCurrentSplitIndex}
        setSplitBillScreen={setSplitBillScreen}
        setShowAllItems={setShowAllItems}
        setGroupedItems={setGroupedItems}
      />

      <CopyKOTModal
        copyKOTVisible={copyKOTVisible}
        setCopyKOTVisible={setCopyKOTVisible}
        groupedFiredItems={groupedFiredItems}
        selectedCopyItems={selectedCopyItems}
        setSelectedCopyItems={setSelectedCopyItems}
        handleCopyKOTConfirm={() => handleCopyKOTConfirm(selectedCopyItems)}
      />

      <CancelOrderItemsModal
        cancelKotItems={cancelKotItems}
        setCancelKotItems={(val) => {
          if (!val) {
            setLineRemarks({});
            setCancelQtyMap({});
          }
          setCancelKotItems(val);
        }}
        cart={cart}
        selectedItemIds={selectedItemIds}
        setSelectedItemIds={setSelectedItemIds}
        groupedKotItems={groupedKotItems}
        toggleAll={toggleAll}
        toggleKot={toggleKot}
        toggleItem={toggleItem}
        currenciesList={currenciesList}
        handleVoid={handleVoid}
        selectedTable={selectedTable}
        filteredCartObj={filteredCartObj}
        loading={loading}
        setLoading={setLoading}
        posConfig={posConfig}
        lineRemarks={lineRemarks}
        setLineRemarks={setLineRemarks}
        cancelQtyMap={cancelQtyMap}
        setCancelQtyMap={setCancelQtyMap}
      />

      <ProductCenterModal
        showProdCenterModal={showProdCenterModal}
        setShowProdCenterModal={setShowProdCenterModal}
        prodItem={prodItem}
        productionCentersOptions={productionCentersOptions}
        cart={cart}
        setCart={setCart}
      />

      <SaleTypeModal saleTypeModalOpen={saleTypeModalOpen} setSaleTypeModalOpen={setSaleTypeModalOpen} saleTypeModalItem={saleTypeModalItem} cart={cart} setCart={setCart} />

      <ParkedOrdersDrawer
        parkedDrawerOpen={parkedDrawerOpen}
        setParkedDrawerOpen={setParkedDrawerOpen}
        storedParkedList={storedParkedList}
        currenciesList={currenciesList}
        retrieveParkedData={retrieveParkedData}
        discardMessage={discardMessage}
      />

      {seatGuestDrawerOpen && <TableFeatures {...props} />}
      {showReprintKotDialog && <ReprintKotDialog isOpen={showReprintKotDialog} onClose={() => setShowReprintKotDialog(false)} groupedProducts={{ ...cart, items: cartItems }} />}
    </>
  );
};

export default React.memo(MenuLayout);
